import { TextField } from "@material-ui/core";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Alert } from "@material-ui/lab";
import { NavLink } from "react-router-dom";
import { getServiceNameWithNickname } from "../../../../utils/getServiceNameWithNickname";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../../utils/consts";
import { parseAxiosError } from "../../../../utils/response";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import DialogModal from "../../../elements/dialogModal/DialogModal";
import PageSpinner from "../../../elements/spinner/PageSpinner";
import { useTranslation } from "react-i18next";
import TwoFa from "../../../elements/twoFa/TwoFa";

import {
  StyledCol,
  StyledScrollTable,
  StyledTable,
  StyledTableBody,
  StyledTableHead,
  StyledTableRow
} from "../../../styles/styledTable";
import { StyledCheckbox, StyledFormGrid } from "../../../styles/styledTabsForm";
import DefaultButton from "../../../styles/materialButtonStyle";
import MaterialCheckbox from "../../../styles/materialCheckbox";
import { StyledApplyToItem, StyledApplyToWrapper } from "../../../styles/styledApplyTo";

const FeeList = ({ fees, fetchFees, notification, setNotification }) => {
  const { t } = useTranslation("feePage");

  const [open, setOpen] = useState(false);
  const [error, setError] = useState({});

  const [checked, setChecked] = useState([]);
  const [massEditingData, setMassEditingData] = useState({
    percent: 0,
    constant: 0,
    min: 0,
    max: 0,
    constantInUSDT: 0
  });

  const inputType = {
    percent: "percent",
    constant: "constant",
    min: "min",
    max: "max",
    constantInUSDT: "constantInUSDT"
  };

  const [currentType, setCurrentType] = useState(null);

  const onChangeApply = (event, index) => {
    setChecked((prev) => {
      const updated = [...prev];
      updated[index] = event.target.checked;
      return updated;
    });
  };

  const handleCheckAll = (event) => {
    setChecked(fees.map(() => event.target.checked));
  };

  const massEditing = async (event) => {
    event.preventDefault();
    const twoFa = event.target.twofa.value;

    let data = document.getElementsByName("applyTo"), res = [];

    for (let i = 0; i < data.length; i++) {
      if (data[i].checked) {
        res.push(data[i].id);
      }
    }

    const postData = {
      data: res,
      type: currentType,
      value: massEditingData[currentType],
      twoFa
    };

    axios.post("/api/fees/mass-edit", postData, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        fetchFees();
        setOpen(false);
        setNotification({ ...notification, visible: true, type: "success", message: t("edit.success") });
      }
    }).catch(error => {
      setOpen(false);
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  const changeInputValue = (event, type) => {
    setMassEditingData({ ...massEditingData, [type]: event.target.value });
  };

  const renderApplyButton = (action) => {
    return (
      <DefaultButton color="success" onClick={action}>
        {t("edit.applyTo")} {checked?.filter(Boolean).length}/{fees.length}
      </DefaultButton>
    );
  };

  useEffect(() => {
    setChecked(fees?.map(() => false) || []);
  }, [fees]);

  const renderMassEdit = () => {
    return (
      <StyledFormGrid className="apply-to-wrapper">
        <StyledApplyToWrapper col="5">
          <StyledApplyToItem>
            <TextField
              className="grid-form__input"
              variant="filled"
              label={t("edit.percent")}
              id={inputType.percent}
              type="text"
              value={massEditingData.percent}
              onChange={(event => changeInputValue(event, inputType.percent))}
            />
            {renderApplyButton(() => {
              setCurrentType(inputType.percent);
              setOpen(true);
            })}
          </StyledApplyToItem>
          <StyledApplyToItem>
            <TextField
              className="grid-form__input"
              variant="filled"
              label={t("edit.constant")}
              id={inputType.constant}
              type="text"
              value={massEditingData.constant}
              onChange={(event => changeInputValue(event, inputType.constant))}
            />
            {renderApplyButton(() => {
              setCurrentType(inputType.constant);
              setOpen(true);
            })}
          </StyledApplyToItem>
          <StyledApplyToItem>
            <TextField
              className="grid-form__input"
              variant="filled"
              label={t("edit.constantInUSDT")}
              id={inputType.constantInUSDT}
              type="text"
              value={massEditingData.constantInUSDT}
              onChange={(event => changeInputValue(event, inputType.constantInUSDT))}
            />
            {renderApplyButton(() => {
              setCurrentType(inputType.constantInUSDT);
              setOpen(true);
            })}
          </StyledApplyToItem>
          <StyledApplyToItem>
            <TextField
              className="grid-form__input"
              variant="filled"
              label={t("edit.min")}
              id={inputType.min}
              type="text"
              value={massEditingData.min}
              onChange={(event => changeInputValue(event, inputType.min))}
            />
            {renderApplyButton(() => {
              setCurrentType(inputType.min);
              setOpen(true);
            })}
          </StyledApplyToItem>
          <StyledApplyToItem>
            <TextField
              className="grid-form__input"
              variant="filled"
              label={t("edit.max")}
              id={inputType.max}
              type="text"
              value={massEditingData.max}
              onChange={(event => changeInputValue(event, inputType.max))}
            />
            {renderApplyButton(() => {
              setCurrentType(inputType.max);
              setOpen(true);
            })}
          </StyledApplyToItem>
        </StyledApplyToWrapper>
      </StyledFormGrid>
    );
  };

  if (!fees) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (fees.length === 0) {
    return <Alert severity="warning">{t("table.emptyData")}</Alert>;
  }

  return (
    <>
      <DialogModal
        open={open}
        setOpen={setOpen}
        title={t("table.twoFa")}
        content={<TwoFa
          handleSubmit={massEditing}
          error={error}
        />}
      />
      {renderMassEdit()}
      <StyledScrollTable>
        <StyledTable
          width="1280"
          size="14"
        >
          <StyledTableHead
            scroll="auto"
            col="11"
          >
            <div>
              <StyledCheckbox position="center">
                <MaterialCheckbox
                  type="checkbox"
                  name="checkAll"
                  id="checkAll"
                  checked={checked?.length > 0 ? checked.every(Boolean) : false}
                  indeterminate={checked?.length > 0 && checked.some(Boolean) && !checked.every(Boolean)}
                  onChange={handleCheckAll}
                />
              </StyledCheckbox>
            </div>
            <div>
              {t("table.service")}
            </div>
            <div>
              {t("table.paymentSystem")}
            </div>
            <div>
              {t("table.currency")}
            </div>
            <div>
              {t("table.type")}
            </div>
            <div>
              {t("table.percent")}
            </div>
            <div>
              {t("table.constant")}
            </div>
            <div>
              {t("table.constantInUSDT")}
            </div>
            <div>
              {t("table.min")}
            </div>
            <div>
              {t("table.max")}
            </div>
            <div>
              {t("table.actions")}
            </div>
          </StyledTableHead>
          <StyledTableBody>
            {fees && fees.map((value, index) => (
              <StyledTableRow
                key={index}
                scroll="auto"
                col="11"
              >
                <StyledCol>
                  <StyledCheckbox position="center">
                    <MaterialCheckbox
                      type="checkbox"
                      name="applyTo"
                      id={value.id}
                      checked={checked?.[index] || false}
                      onChange={(event) => onChangeApply(event, index)}
                    />
                  </StyledCheckbox>
                </StyledCol>
                <StyledCol>
                  {getServiceNameWithNickname(value.baseFee.service.name, value.baseFee.service.nickname)}
                </StyledCol>
                <StyledCol>
                  {value.baseFee.paymentSystem.name}
                </StyledCol>
                <StyledCol>
                  {value.baseFee.currency.asset}
                </StyledCol>
                <StyledCol>
                  {value.baseFee.type}
                </StyledCol>
                <StyledCol>
                  {Math.round((value.percent * 100) * 1000) / 1000} %
                </StyledCol>
                <StyledCol>
                  {value.constant}
                </StyledCol>
                <StyledCol>
                  {value.constantInUSDT}
                </StyledCol>
                <StyledCol>
                  {value.min}
                </StyledCol>
                <StyledCol>
                  {value.max}
                </StyledCol>
                <StyledCol inline>
                  <NavLink
                    className="table-action table-action_info"
                    to={"/clients/fee/" + value.id}
                  >
                    <span className="icon-light-edit" />
                    {t("table.edit")}
                  </NavLink>
                </StyledCol>
              </StyledTableRow>
            ))}
          </StyledTableBody>
        </StyledTable>
      </StyledScrollTable>
    </>
  );
};
export default FeeList;